import { IconCircleCheck } from "@tabler/icons-react";
import "../Styles/CheckoutStepper.css";

/**
 * Stepper réutilisable pour tout le tunnel d'achat.
 * @param {string[]} steps - labels des étapes, ex: ["Panier", "Adresse", "Paiement"]
 * @param {number} currentStep - étape active, 1-indexée
 */
const CheckoutStepper = ({ steps, currentStep }) => (
  <div className="checkout-stepper">
    {steps.map((label, i) => {
      const stepNumber = i + 1;
      const isDone = stepNumber < currentStep;
      const isActive = stepNumber === currentStep;
      return (
        <div key={label} style={{ display: "flex", alignItems: "center" }}>
          <div
            className={`checkout-step ${isActive ? "is-active" : ""} ${isDone ? "is-done" : ""}`}
          >
            <div className="checkout-step-circle">
              {isDone ? <IconCircleCheck size={18} /> : stepNumber}
            </div>
            <span className="checkout-step-label">{label}</span>
          </div>
          {stepNumber < steps.length && (
            <div className={`checkout-step-line ${isDone ? "is-done" : ""}`} />
          )}
        </div>
      );
    })}
  </div>
);

export default CheckoutStepper;
